import { environment } from '../environments/environment'
import brandInfo from '../environments/brand.json'

// Default Okta configuration
const defaultConfig = {
    clientId: "0oa4iunald8h7tx801d7",
    issuer: "https://safeguard-uat-d2c.oktapreview.com/oauth2/aus4hrpxrmc6JZ4OD1d7",
    redirectUri: window.location.origin,
    scopes: ["openid", "profile", "email"],
    pkce: true
}

// Find brand-specific config or use default
const brandConfig = environment.oktaConfig.find(config => config.brandName === brandInfo.brand) || defaultConfig

export default {
    oidc: {
        clientId: brandConfig.clientId,
        issuer: brandConfig.issuer,
        redirectUri: brandConfig.redirectUri,
        scopes: brandConfig.scopes,
        pkce: true
    }
}